import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { banner, search } from "../../imgUrl";

const Banner = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState(""); // Add a query state to capture search input

  // Handle input change to capture search query
  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  // Handle search box click to navigate to the search page
  const handleSearchBoxClick = () => {
    navigate("/search"); // Navigate to the search page without query initially
  };

  return (
    <div>
      <div className="main-banner">
        <div className="banner-img">
          <img src={banner} alt="banner" />
        </div>
        <div className="banner-content">
          <h2>Buy Branded, Generic &amp; Surgical Medicines</h2>
          <div className="search-box">
            <input
              type="text"
              placeholder="Search Medicines"
              value={query}
              onChange={handleInputChange} // Capture input change
              onClick={handleSearchBoxClick} // Navigate to the search page when the search box is clicked
              style={{ cursor: "pointer" }} // Add pointer cursor for clarity
            />
            <img
              src={search}
              alt="search icon"
              style={{ cursor: "pointer" }} // Keep the pointer cursor for consistency
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
